import React,{useEffect,useState} from 'react'
import { Col, Row,Card } from "react-bootstrap";
import '../css/category.css'
import $ from 'jquery'
function Category({ data }) {
 
  return (
    <>
       {/* <Card className="rounded">
      <Card.Body>
        <div className="text-center">
          <h4>Card Header Text</h4>
        </div>
        <img src="..." className="img-fluid" alt="Card image" />
        <Card.Text>
          Some quick example text to build on the card title and make up the bulk of
          the card's content.
        </Card.Text>
      </Card.Body>
    </Card> */}
      
     
          <Row className='row-cat'>
                {data.map(Category =>{
                  return (
                    <Col className='category-1' style={{backgroundImage: `url(${Category.src})`}}>
                    <div className='cat-overlay'></div>
                    <p>Shop for</p>
                          <h4>{Category.name}</h4>
                    <ul>
                              {Category.list.map(l => {
                                  return (
                                      <li className={`${l.name == 'More' ? "last" : ""} `}>{l.name}</li>
                            )
                        })}
                    </ul>
                    
                </Col>
                  )
              })}
              
            </Row>
        
      </>
  )
}

export default Category